import { Box, Grid } from '@mui/material';
import { ButtonCustom } from 'app/components/elements/ButtonCustom';
import { ReactNode } from 'react';

export const FILTER_CONTROL_HEIGHT = 46;

export const filterFieldSx = {
  padding: 0,
  minHeight: `${FILTER_CONTROL_HEIGHT}px`,
  height: `${FILTER_CONTROL_HEIGHT}px`,
  width: '100%'
};

type PdfMapFiltersBarProps = {
  children: ReactNode;
  onClearFilters?: () => void;
  showClearFilters?: boolean;
};

export const PdfMapFilterBar = ({
  children,
  showClearFilters,
  onClearFilters
}: PdfMapFiltersBarProps) => {
  return (
    <Box
      sx={{
        width: '100%',
        borderRadius: 2,
        p: { xs: 1.5, sm: 2 }
      }}>
      <Grid container spacing={2} alignItems="flex-end">
        {children}

        <Grid
          item
          xs={12}
          lg="auto"
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'stretch', sm: 'center' },
            justifyContent: 'flex-end',
            gap: 1.25,
            width: { xs: '100%', lg: 'auto' },
            ml: { lg: 'auto' },
            flexShrink: 0
          }}></Grid>
        {showClearFilters && (
          <ButtonCustom
            isSecondary
            sx={{
              width: { xs: '100%', sm: 'max-content' },
              height: `${FILTER_CONTROL_HEIGHT}px`,
              bgcolor: '#fff',
              border: '1px solid #ccc',
              '&:hover': {
                bgcolor: '#f1f1f1'
              }
            }}
            label="Clear filters"
            onClick={onClearFilters}
          />
        )}
      </Grid>
    </Box>
  );
};

export const PdfMapFilterField = ({
  children,
  xs = 4,
  sm = 4,
  md = 2
}: {
  children: ReactNode;
  xs?: number;
  sm?: number;
  md?: number;
}) => (
  <Grid item xs={xs} sm={sm} md={md} sx={{ minWidth: 0 }}>
    {children}
  </Grid>
);
